/**
 * @generated SignedSource<<fbc53bbabd98ee091967714ea96ccf0e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type confluenceSearchResponse_AtlassianSearchPage$data = {
  readonly __typename: "ConfluenceSearchResponse";
  readonly content: {
    readonly ari: string | null | undefined;
    readonly space: {
      readonly ari: string | null | undefined;
      readonly links: {
        readonly webui: string | null | undefined;
      } | null | undefined;
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly type: string | null | undefined;
  } | null | undefined;
  readonly excerpt: string | null | undefined;
  readonly lastModified: string | null | undefined;
  readonly links: {
    readonly base: string | null | undefined;
  } | null | undefined;
  readonly title: string | null | undefined;
  readonly url: string | null | undefined;
  readonly " $fragmentType": "confluenceSearchResponse_AtlassianSearchPage";
};
export type confluenceSearchResponse_AtlassianSearchPage$key = {
  readonly " $data"?: confluenceSearchResponse_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"confluenceSearchResponse_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "ari"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "confluenceSearchResponse_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "excerpt"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "ScalarField",
      "name": "lastModified"
    },
    {
      "concreteType": "LinksContextBase",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "base"
        }
      ]
    },
    {
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "concreteType": "Space",
          "kind": "LinkedField",
          "name": "space",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "name": "name"
            },
            {
              "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
              "kind": "LinkedField",
              "name": "links",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "webui"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "ConfluenceSearchResponse"
};
})();

(node as any).hash = "56720713632e89616c1b52d367ff72b8";

export default node;
